import { useEffect, useRef, useState } from "react";
import { useInView, useReducedMotion } from "framer-motion";

/*
 * Număr care crește blând când intră în vedere (contorul pădurii, Semințe...).
 * Satisfăcător, cald, nu agresiv.
 */
export default function CountUp({ value = 0, duration = 1400, className = "", format }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-30px" });
  const reduce = useReducedMotion();
  const [n, setN] = useState(reduce ? value : 0);

  useEffect(() => {
    if (!inView || reduce) { setN(value); return; }
    let raf; const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      setN(Math.round(value * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration, reduce]);

  const shown = format ? format(n) : n.toLocaleString("ro-RO");
  return <span ref={ref} className={className}>{shown}</span>;
}
